module.exports = __webpack_public_path__ + "static/media/answers-profile-pic-2.9fea5e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/answers-profile-pic-2.png
// module id = 1052
// module chunks = 0